"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76.0021H2.24a.56.56,0,0,0-.63.64v19.51a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.6421a.56.56,0,0,0-.63-.64Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.875,9.51172,15.15331,8.1748a.751.751,0,0,0-.66016-.39355h-.9834V7.28711a.75019.75019,0,0,0-.75-.75H7.92382a.75019.75019,0,0,0-.75.75V12.7207a.75018.75018,0,0,0,.75.75h.31982c0,.00623-.00342.01136-.00342.01764a.98828.98828,0,1,0,1.97656,0c0-.00628-.00341-.01141-.00341-.01764h3.29541c-.00025.00623-.00367.01136-.00367.01764a.98841.98841,0,1,0,1.97681,0c0-.00628-.00342-.01141-.00342-.01764h.59766a.75019.75019,0,0,0,.75-.75V10.626a.7523.7523,0,0,0-.28516-.58887Zm-1.8291-.23047.583,1.0791a.75892.75892,0,0,0,.19532.23242l.50195.39649v.98144H13.50975V9.28125ZM8.67382,8.03711h3.33593V11.9707H8.67382Zm11.31054,2.3291A8.0011,8.0011,0,0,1,18.21,15.38574a.74992.74992,0,0,1-1.166-.94336,6.41269,6.41269,0,0,0,1.44043-4.07617,6.48753,6.48753,0,0,0-6.10742-6.46527A.74906.74906,0,0,1,11.31151,4.9541l-1.292-1.292a.74973.74973,0,0,1,0-1.06055l1.292-1.292a.74992.74992,0,0,1,1.06055,1.06055l-.029.02911A7.9878,7.9878,0,0,1,19.98436,10.36621Zm-5.98828,6.70606a.74972.74972,0,0,1,0,1.06054L12.67284,19.457a.74992.74992,0,0,1-1.06055-1.06055l.06153-.06146A7.97888,7.97888,0,0,1,5.36034,5.92969a.74971.74971,0,1,1,1.24609.834,6.48095,6.48095,0,0,0,5.0293,10.0694l-.02344-.0235A.74992.74992,0,0,1,12.67284,15.749Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;